import * as React from 'react';
import { NewbuildingLayoutsContext } from '../shared/context';
import { addFavorites, removeFavorites } from '../services/favorites';
export var useFavorite = function useFavorite(_ref) {
  var setFavoriteStatus = _ref.setFavoriteStatus;
  var _React$useContext = React.useContext(NewbuildingLayoutsContext),
    httpApi = _React$useContext.httpApi,
    logger = _React$useContext.logger;
  var addOfferToFavorites = React.useCallback(function (offerId) {
    setFavoriteStatus(offerId, true);
    addFavorites({
      httpApi: httpApi,
      logger: logger,
      params: {
        offerId: offerId
      }
    }).then(function (result) {
      if (!result) {
        setFavoriteStatus(offerId, false);
      }
    });
  }, [setFavoriteStatus]);
  var removeOfferFromFavorites = React.useCallback(function (offerId) {
    setFavoriteStatus(offerId, false);
    removeFavorites({
      httpApi: httpApi,
      logger: logger,
      params: {
        offerId: offerId
      }
    }).then(function (result) {
      if (!result) {
        setFavoriteStatus(offerId, true);
      }
    });
  }, [setFavoriteStatus]);
  return {
    addOfferToFavorites: addOfferToFavorites,
    removeOfferFromFavorites: removeOfferFromFavorites
  };
};